import {Container, HeaderTitle, HeaderWrapper, LogoContainer, Title} from '../styled';
import usePropertyLinkInfo from 'components/PageSideBarUniversalLink/usePropertyLinkInfo';
import {useKioskoStore} from 'context/kiosko/useKioskoStore';
import {LanguageButton} from 'components/LanguageButton';

function Navbar() {
  const {logo, title} = usePropertyLinkInfo();
  const isKiosko = useKioskoStore(state => state.connection.isConnected);
  return (
    <HeaderWrapper className="navbar">
      <Container>
        <LogoContainer className="navbar__logo">
          {logo && <img src={logo} alt="housing Logo" className="navbar__logo-img" />}
        </LogoContainer>
        <HeaderTitle className="navbar__title">
          <Title className="navbar__title-text">{title}</Title>
        </HeaderTitle>
        {isKiosko && <LanguageButton />}
      </Container>
    </HeaderWrapper>
  );
}

export {Navbar};
